export default function AnnouncementBar() {
  return (
    <div className="w-full bg-ink text-white text-center py-2.5 text-[13px] tracking-wide">
      <p>
        This announcement bar can be used to inform visitors of something important.
      </p>
    </div>
  );
}